import { Svg, Path } from '@react-pdf/renderer';

export default function PDFFORALogo() {
  return (
    <Svg
      width={48}
      height={12}
      viewBox='0 0 48 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <Path
        d='M0 0.858154H7.51699V2.75969H2.16977V4.85113H6.72643V6.73663H2.16977V11.1259H0V0.858154Z'
        fill='#FEFFFF'
      />
      <Path
        d='M10.6631 5.99194C10.6631 3.06072 12.8794 0.699707 15.9794 0.699707C19.0794 0.699707 21.2958 3.06072 21.2958 5.99194C21.2958 8.92317 19.0794 11.3002 15.9794 11.3002C12.8794 11.3002 10.6631 8.9392 10.6631 5.99194ZM19.0329 5.99194C19.0329 4.16958 17.7463 2.71198 15.9951 2.71198C14.2439 2.71198 12.9265 4.16958 12.9265 5.99194C12.9265 7.8143 14.2282 9.28793 15.9951 9.28793C17.762 9.28793 19.0329 7.83033 19.0329 5.99194Z'
        fill='#FEFFFF'
      />
      <Path
        d='M25.2471 0.858154H29.5557C32.5161 0.858154 34.0658 2.63292 34.0658 4.8351C34.0658 6.15039 33.3993 7.41808 32.1593 8.09903L34.2516 11.1255H31.7564L30.2066 8.71685C29.9121 8.76445 29.6488 8.79602 29.3543 8.79602H27.4168V11.1255H25.2471V0.858154ZM29.618 6.89497C30.8889 6.89497 31.7725 5.95999 31.7725 4.8351C31.7725 3.71021 30.8893 2.74366 29.6336 2.74366H27.4173V6.89497H29.618Z'
        fill='#FEFFFF'
      />
      <Path
        d='M41.4901 0.858154H43.629L47.9998 11.1259H45.7992L45.1174 9.49398H40.0182L39.3364 11.1259H37.1201L41.491 0.858154H41.4901ZM44.4347 7.76681L43.2722 4.83559C42.9624 4.05895 42.5747 3.02925 42.559 2.99768C42.5434 3.02925 42.1562 4.05943 41.8459 4.83559L40.6833 7.76681H44.4347Z'
        fill='#FEFFFF'
      />
    </Svg>
  );
}
